import { ScrollOnLoadComponent } from './components/shared/scroll-on-load';

import { CollapseComponent } from '@opten/collapse';
import { factory } from '@opten/compiler/factory';

import { BookComponent } from './components/book/book';
import { AlertComponent } from './components/shared/alert';
import { GlobalVarsComponent } from './components/shared/globalvars';
import { InputComponent } from './components/shared/input';
import { MediaSliderComponent } from './components/shared/media-slider';
import { ModalComponent } from './components/shared/modal';
import { PageTopComponent } from './components/shared/page-top';
import { PseudoLinkComponent } from './components/shared/pseudo-link';
import { ScrollToComponent } from './components/shared/scroll-to';
import { PasswordRevealComponent } from './components/shared/password-reveal';

const initialize = factory([
	MediaSliderComponent,
	ModalComponent,
	CollapseComponent,
	ScrollToComponent,
	PageTopComponent,
	BookComponent,
	InputComponent,
	PasswordRevealComponent,
	PseudoLinkComponent,
	AlertComponent,
]);

initialize(document.body);

const vars = new GlobalVarsComponent();
const scrollOnLoad = new ScrollOnLoadComponent();
